import React from 'react';
interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}
export function ProgressBar({
  currentStep,
  totalSteps
}: ProgressBarProps) {
  // Calculate percentage, ensuring it doesn't exceed 100%
  const progress = Math.min(100, Math.max(0, (currentStep + 1) / totalSteps * 100));
  return <div className="w-full" data-id="element-24">
      <div className="flex justify-between text-xs font-medium text-slate-500 mb-2 uppercase tracking-wider" data-id="element-25">
        <span data-id="element-26">Progresso</span>
        <span data-id="element-27">{Math.round(progress)}%</span>
      </div>
      <div className="h-2 w-full bg-slate-200 rounded-full overflow-hidden" data-id="element-28">
        <div className="h-full bg-teal-600 transition-all duration-500 ease-out rounded-full" style={{
        width: `${progress}%`
      }} data-id="element-29" />
      </div>
    </div>;
}